import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareDeploymentsNextGenRoute: InvariantJiraRoute = {
	name: 'software-deployments',
	path: '/jira/software/projects/:projectKey/deployments',
};
